import React from 'react'
//TODO fix import
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import { TeamShieldColorsIcon } from '../../../Common/TeamColorShield'
import { colors } from '@mobi/component-library/Foundations'
import { TeamColor } from '../types'
import { KambiSportName } from '@mobi/api-types/kambi/sports'

const defaultshieldTeamColor: TeamColor = {
  team: '',
  mainColor: colors.white,
  secondaryColor: '#EDEDED',
}

export const DefaultIcon: React.FC<{
  defaultIconType: DefaultIconType
  sportName?: KambiSportName
  size: string
  showDefaultShield: boolean
}> = ({ sportName, defaultIconType, size, showDefaultShield }) => {
  if (sportName && defaultIconType === 'sport-icon') {
    return <SportsIcon size={size} sport={sportName} />
  } else if (defaultIconType === 'team-icon' && showDefaultShield) {
    return <TeamShieldColorsIcon size={size} colors={defaultshieldTeamColor} />
  }
  return null
}

//=========
// Types
//=========

export type DefaultIconType = 'sport-icon' | 'team-icon' | null
